// extracted by mini-css-extract-plugin
export default {"icon-container":"styles_icon-container__58OW+","icon":"styles_icon__hbDu3"};